if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.isWWCollectionQuickAdd =
          this.dataset.wwCollectionQuickAdd === 'true';

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart && !this.isWWCollectionQuickAdd) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );

          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (this.isWWCollectionQuickAdd) {
          formData.append('sections', 'header');
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');

              this.error = true;
              return;
            }

            const startMarker =
              CartPerformance.createStartingMarker(
                'add:wait-for-subscribers'
              );

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });
            }

            this.error = false;

            if (this.isWWCollectionQuickAdd) {
              this.updateCollectionCartUI(response);
              this.showAddedState();
              return;
            }

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(response);
                }
              );
            }
          })
          .catch((e) => {
            console.error(e);
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          });
      }

      updateCollectionCartUI(response) {
        if (!response.sections) return;

        const headerHTML = response.sections.header;

        if (!headerHTML) return;

        const parser = new DOMParser();
        const parsedHTML = parser.parseFromString(
          headerHTML,
          'text/html'
        );

        const currentCartIcon =
          document.getElementById('cart-icon-bubble');

        const updatedCartIcon =
          parsedHTML.getElementById('cart-icon-bubble');

        if (currentCartIcon && updatedCartIcon) {
          currentCartIcon.replaceWith(updatedCartIcon);
        }
      }

      showAddedState() {
        const label = this.submitButton.querySelector(
          '.ww-collection-quick-add__label'
        );

        const added = this.submitButton.querySelector(
          '.ww-collection-quick-add__added'
        );

        if (!label || !added) return;

        label.classList.add('hidden');

        added.textContent = '✓ Added';
        added.classList.remove('hidden');
        added.setAttribute('aria-hidden', 'false');

        window.clearTimeout(this.addedStateTimer);

        this.addedStateTimer = window.setTimeout(() => {
          added.classList.add('hidden');
          added.setAttribute('aria-hidden', 'true');
          label.classList.remove('hidden');
        }, 1400);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!window.__wwCollectionCardInteractions) {
  window.__wwCollectionCardInteractions = true;

  document.addEventListener('click', (event) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const mediaLink = event.target.closest(
      '[data-ww-card-media-link]'
    );

    if (!mediaLink) return;

    const secondaryImage =
      mediaLink.querySelector('img:nth-of-type(2)');

    if (!secondaryImage) return;

    if (
      !mediaLink.classList.contains(
        'ww-collection-card__media-link--swapped'
      )
    ) {
      event.preventDefault();

      mediaLink.classList.add(
        'ww-collection-card__media-link--swapped'
      );
    }
  });
}